







































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * Helpers
 */
import { getFullName } from "@/utils/users-helpers";
import { smartDisplayMinutes, getElegantDateString, getShortTimeString } from "@/utils/date-helpers";

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import bookingsAPI from "@/api/bookings";

/**
 * Types
 */
import { CalendarTimedEvent } from './Calendar.vue';

/**
 * Composant de fenêtre modale du détail d'une réservation horaire.
 */
@Component({ mixins: [mixinsAPI] })
export default class BookingDetailsDialog extends Vue {
	$refs!: {
		modal: Dialog
	};

	/** Injections */
	getFullName = getFullName;
	smartDisplayMinutes = smartDisplayMinutes;
	getElegantDateString = getElegantDateString;
	getShortTimeString = getShortTimeString;

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' })
	openInfo: any;
	@Action('openError', { namespace: 'snackbar' })
	openError: any;

	/** Propriétés */
	@Prop({ default: 'fr-FR' })
	locale!: string;


	/** Attributs */
	isLoading = false;
	date: Date | null = null;
	durationInMinutes: number | null = null;
	user: any | null = null;
	service: any | null = null;
	isWaitingForSynchronization: boolean | null = null;
	isEditable: boolean | null = null;

	get endDate() {
		const endDate = new Date(this.date as Date);
		const durationInMinutes = this.durationInMinutes as number;
		endDate.setMinutes(endDate.getMinutes() + durationInMinutes);
		return endDate;
	}

	/** Méthodes */
	async open(event: CalendarTimedEvent) {
		this.date = new Date(Date.parse(event.date));
		const hoursMinutesArray = event.time.split(':');
		this.date.setHours(parseInt(hoursMinutesArray[0], 10));
		this.date.setMinutes(parseInt(hoursMinutesArray[1], 10));
		this.durationInMinutes = event.duration;

		this.isWaitingForSynchronization = event.isWaitingForSynchronization;
		this.isEditable = event.isEditable;
		this.service = event.customData.service;
		this.user = event.customData.user;

		this.$refs.modal.open();

	}
	close() {
		this.$refs.modal.close();
	}

	async handleDelete() {
		const r = confirm(this.$t("booking.confirm_cancellation__").toString());
		if (!r) {
			return;
		}
		this.isLoading = true;
		try {
			await bookingsAPI.cancel({
				bookedDate: this.date as Date,
				userID: this.user.id,
				serviceID: this.service.id,
				hasItems: false
			});
			this.$emit('onDeleteSuccess');
			this.isLoading = false;
			this.openInfo(this.$t('snackbar.success'));
			this.close();

		}
		catch (ex) {
			(this as any).handleAPIError(ex);
			this.isLoading = false;
		}
	}
}
